import Vue from "vue";
import firebase from "firebase/app";
import { firestorePlugin } from "vuefire";
import "firebase/firestore";
import firebaseConfig from "../../../../firebase/firebaseConfig";

Vue.use(firestorePlugin);

// 管理コンソール用のauthDomainに書き換える
if (!location.host.includes("localhost")) {
  firebaseConfig.authDomain = location.host
}
const db = firebase.initializeApp(firebaseConfig).firestore();

Object.defineProperty(Vue.prototype, "$db", {
  get() {
    return db;
  }
});

export default db;
